/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */
import {Vue} from 'vue-property-decorator';
import {MutationTree} from 'vuex';
import {DlcInterface, FavouritesInterface, GameStateInterface, SpeciesInterface} from '@/store/modules/game/types';

/**
 * Game state mutations.
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

export const mutations: MutationTree<GameStateInterface> = {
    /**
     * @param {GameStateInterface} state
     * @param {boolean} locked
     */
    setLocked(state: GameStateInterface, locked: boolean): void {
        Vue.set(state, 'locked', locked);
    },

    /**
     * @param {GameStateInterface} state
     * @param {string} zoo
     */
    setZoo(state: GameStateInterface, zoo: string): void {
        Vue.set(state, 'zoo', zoo);
    },

    /**
     * @param {GameStateInterface} state
     * @param {number} cash
     */
    setCash(state: GameStateInterface, cash: number): void {
        const cashAdj: number = Math.floor(cash / 100);
        if (cashAdj > 0) {
            Vue.set(state, 'cash', cashAdj);
        }
    },

    /**
     * @param {GameStateInterface} state
     * @param {DlcInterface[]} dlc
     */
    setDlc(state: GameStateInterface, dlc: DlcInterface[]): void {
        Vue.set(state, 'dlc', dlc);
    },

    /**
     * @param {GameStateInterface} state
     * @param {SpeciesInterface[]} species
     */
    setSpecies(state: GameStateInterface, species: SpeciesInterface[]): void {
        Vue.set(state, 'species', species);
    },

    /**
     * @param {GameStateInterface} state
     * @param {FavouritesInterface[]} favourites
     */
    setFavourites(state: GameStateInterface, favourites: FavouritesInterface[]): void {
        Vue.set(state, 'favourites', favourites);
    },

    /**
     * @param {GameStateInterface} state
     * @param {FavouritesInterface[]} favourite
     */
    addFavourite(state: GameStateInterface, favourite: FavouritesInterface): void {
        const index: number =
            state.favourites.findIndex((item: FavouritesInterface) => item['@id'] === favourite['@id']);

        if (index >= 0) {
            return;
        }

        Vue.set(state, 'favourites', state.favourites.concat([favourite]));
    },

    /**
     * @param {GameStateInterface} state
     * @param {FavouritesInterface} favourite
     */
    removeFavourite(state: GameStateInterface, favourite: FavouritesInterface): void {
        const index: number =
            state.favourites.findIndex((item: FavouritesInterface) => item['@id'] === favourite['@id']);

        if (index >= 0) {
            state.favourites.splice(index, 1);
        }
    },
};
